<template>
  <b-row>

    <b-col class="container text-right">
      <b-button
        variant="primary"
        @click="onBtnAddClicked"
      >
        <feather-icon
          icon="PlusIcon"
          class="mr-25"
        />
        <span>เพิ่มข้อมูล</span>
      </b-button>
    </b-col>

    <b-card class="mt-2 col-12">
      <b-tabs>
        <b-tab
          v-for="tab in tabs"
          :key="tab.title"
          :title="tab.title"
          lazy
          @click.prevent="setActiveTabName(tab.mode)"
        >
          <b-col cols="12">
            <SearchFilter
             :mode="tab.mode" 
             @handleSubmit="searchFilterSubmit"
            />
          </b-col>

        </b-tab>
      </b-tabs>

    </b-card>

    <b-col
      v-for="tab in activeTab"
      :id="tab"
      :key="tab"
      cols="12"
    >
      <commonTable
        ref="tableCommon"
        :mode="tab"
      />
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BTabs, BTab, BButton, BCard, BCardHeader, BCardBody,
} from 'bootstrap-vue'
import commonTable from './components/commonTable.vue'
import SearchFilter from './components/SearchFilter.vue'


export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    commonTable,
    SearchFilter,
  },
  data() {
    return {
      tabs: [
        { title: 'มติการประชุม', mode: 'List' },
      ],
      activeTab: ['List'],
    }
  },
  methods: {
    setActiveTabName(name) {
      this.activeTab = []
      this.activeTab.push(name)
    },
    searchFilterSubmit(params){
      console.log('this', this.$refs)
        this.$refs.tableCommon[0].onSearchSubmit(params)
    },
    onBtnAddClicked() {
      window.open(this.$router.resolve({ name: 'ConclusionManage'}).href, '_blank');
    }
  },
}
</script>

 <style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
